import { useState, useEffect } from 'react';
import styles from './ExpandingSlider.module.scss';
import ruby from './assets/images/ruby.avif';
import sapphire from './assets/images/sapphire.avif';
import citrine from './assets/images/citrine.avif';
import amethyst from './assets/images/amethyst.avif';
import chrysolite from './assets/images/chrysolite.avif';

const slides = [
  {
    id: 0,
    src: citrine,
    title: 'citrine',
    desc: 'The golden glow of nature',
    shadowColor: '#FFD700',
  },
  {
    id: 1,
    src: chrysolite,
    title: 'chrysolite',
    desc: 'Harmonizes space',
    shadowColor: '#35dc14ff',
  },
  {
    id: 2,
    src: sapphire,
    title: 'sapphire',
    desc: 'The depth of the blue sky',
    shadowColor: '#4169E1',
  },
  {
    id: 3,
    src: amethyst,
    title: 'amethyst',
    desc: 'The tranquility of the night stars',
    shadowColor: '#9370DB',
  },
  {
    id: 4,
    src: ruby,
    title: 'ruby',
    desc: 'The passion of red fire',
    shadowColor: '#cd3232ff',
  },
];

const ExpandingSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return;
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
    setIsAutoPlaying(false);
    setActiveIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
    setIsAutoPlaying(true);
  };

  return (
    <div className={styles.sliderContainer}>
      <div className={styles.sliderWrapper}>
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`${styles.slide} ${
              index === activeIndex || index === hoveredIndex
                ? styles.active
                : ''
            }`}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <img
              src={slide.src}
              alt={slide.title}
              className={styles.slideImage}
            />
            <div className={styles.overlayText}>
              <h2 style={{ textShadow: `0px 0px 10px ${slide.shadowColor}` }}>
                {slide.title}
              </h2>
              <p className='slideDesc'>{slide.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExpandingSlider;
